import { jsxs as u, jsx as t } from "react/jsx-runtime";
import { useState as i, useRef as b, useEffect as x } from "react";
import { isEmpty as _ } from "es-toolkit/compat";
import j from "../../utils/classNames.js";
import A from "../../hooks/useEffectOnce.js";
import D from "../clearableInput/ClearableInput.js";
import G from "../expander/ExpanderPanel.js";
import V from "./ListMenuGroup.js";
import $ from "../../hooks/useEsc.js";
import X from "../../hooks/useWindowResize.js";
import Z from "../../hooks/useKey.js";
import { debounce as q } from "es-toolkit/function";
const J = 10, Q = 580, U = (n, s, r) => n.map((o) => ({
  ...o,
  navItems: o.navItems.filter(
    (a) => a[r].toLowerCase().includes(s.toLowerCase())
  )
})), Y = (n) => n.find(({ navItems: s }) => !_(s)), pe = (n) => {
  const {
    menuItems: s,
    focusFilter: r = !1,
    enableFilter: o = !1,
    filterPlaceholder: a,
    onFilterChange: v = () => {
    },
    notFoundMessage: L,
    className: w = "",
    groupClassName: k = "",
    responsive: f = !0,
    autoClose: F = !0,
    filterKey: O = "key",
    trailingInputAddon: h,
    ...R
  } = n, [l, g] = i(""), [T, H] = i(!1), [y, M] = i(!1), [K, S] = i(""), c = b(null), m = b(null), N = () => {
    if (f && m.current) {
      const [e] = m.current.getElementsByClassName("active");
      S(
        /* @__PURE__ */ u("div", { className: "display-flex align-items-center", children: [
          /* @__PURE__ */ t("span", { className: "rioglyph rioglyph-menu-hamburger margin-right-10" }),
          /* @__PURE__ */ t("span", { children: e?.innerText })
        ] })
      );
    }
  };
  $(() => {
    o && c.current === document.activeElement && g("");
  });
  const E = q(() => {
    N(), H(window.innerWidth < Q);
  }, J);
  x(E, []), X(E);
  const d = () => {
    c.current?.focus();
  };
  Z((e) => {
    (e.metaKey || e.ctrlKey) && e.key === "k" && (e.preventDefault(), d());
  }), A(() => {
    r && d();
  }), x(() => N, [s]);
  const z = () => r && d(), B = (e) => {
    g(e), v(e);
  }, I = U(s, l, O), P = (e) => {
    const p = e.target.parentElement?.tagName.toLowerCase() === "li";
    F && p && M(!1);
  }, W = j(
    "form-group",
    "margin-bottom-5",
    "padding-left-15",
    "padding-right-15",
    "padding-bottom-15",
    "position-sticky",
    "top-0",
    "z-index-1"
  ), C = /* @__PURE__ */ u("div", { ...R, className: `ListMenu ${w} ${l ? "filtered" : ""}`, ref: m, children: [
    o && /* @__PURE__ */ t("div", { className: W, children: /* @__PURE__ */ u("div", { className: "input-group width-100pct", children: [
      /* @__PURE__ */ t("span", { className: "input-group-addon", children: /* @__PURE__ */ t("span", { className: "rioglyph rioglyph-search", "aria-hidden": "true" }) }),
      /* @__PURE__ */ t(
        D,
        {
          value: l,
          inputRef: c,
          placeholder: a,
          onChange: B,
          onClear: z
        }
      ),
      h && h
    ] }) }),
    !Y(I) && /* @__PURE__ */ t("div", { className: "padding-top-25 text-center text-color-gray", children: L }),
    I.map((e, p) => /* @__PURE__ */ t(V, { className: k, menuGroup: e }, p))
  ] });
  return f && T ? /* @__PURE__ */ t(
    G,
    {
      title: K,
      bsStyle: "default",
      open: y,
      onToggle: () => M(!y),
      unmountOnExit: !1,
      className: "shadow-default",
      children: /* @__PURE__ */ t("div", { onClick: P, children: C })
    }
  ) : C;
};
export {
  pe as default
};
//# sourceMappingURL=ListMenu.js.map
